import React from 'react';
import Layout from '../components/layout/Layout';
import { Badge } from '../components/ui/badge';
import { companyInfo } from '../data/mock';
import { Shield } from 'lucide-react';

const AvisoPrivacidadPage = () => {
  return (
    <Layout>
      <section className="py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <Badge className="mb-4 bg-emerald-100 text-emerald-700 hover:bg-emerald-100">
              <Shield className="h-3.5 w-3.5 mr-1.5" />
              Legal
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Aviso de Privacidad
            </h1>
            <p className="text-gray-600">
              Última actualización: Julio 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <h2>1. Responsable del tratamiento de datos personales</h2>
            <p>
              <strong>{companyInfo.name}</strong> (en adelante "UPIM"), con domicilio en 
              {companyInfo.address}, es responsable del tratamiento de sus datos personales.
            </p>

            <h2>2. Datos personales que recabamos</h2>
            <p>Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar sus datos personales de distintas formas:</p>
            <ul>
              <li>Nombre completo</li>
              <li>Correo electrónico</li>
              <li>Número telefónico</li>
              <li>Dirección</li>
              <li>Identificación oficial</li>
              <li>Datos fiscales (en caso de requerir factura)</li>
              <li>Información profesional relacionada con el sector inmobiliario</li>
            </ul>

            <h2>3. Finalidades del tratamiento de datos</h2>
            <p>Sus datos personales serán utilizados para las siguientes finalidades:</p>
            <h3>Finalidades primarias:</h3>
            <ul>
              <li>Gestionar su afiliación a UPIM</li>
              <li>Procesar pagos de membresía</li>
              <li>Proporcionar acceso a beneficios y servicios</li>
              <li>Emitir credenciales de afiliado</li>
              <li>Gestionar inscripciones a eventos y capacitaciones</li>
            </ul>
            <h3>Finalidades secundarias:</h3>
            <ul>
              <li>Enviar comunicaciones sobre eventos, promociones y noticias</li>
              <li>Realizar encuestas de satisfacción</li>
              <li>Elaborar estadísticas y análisis internos</li>
            </ul>

            <h2>4. Derechos ARCO</h2>
            <p>
              Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos 
              y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la 
              corrección de su información personal en caso de que esté desactualizada, sea inexacta o 
              incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando 
              considere que la misma no está siendo utilizada conforme a los principios, deberes y 
              obligaciones previstas en la normativa (Cancelación); así como oponerse al uso de sus datos 
              personales para fines específicos (Oposición).
            </p>

            <h2>5. Medios para ejercer derechos ARCO</h2>
            <p>
              Para ejercer cualquiera de los derechos ARCO, usted deberá presentar la solicitud 
              respectiva a través del correo electrónico: <strong>{companyInfo.email}</strong>
            </p>

            <h2>6. Transferencia de datos</h2>
            <p>
              Sus datos personales no serán transferidos a terceros sin su consentimiento, salvo las 
              excepciones previstas en la Ley Federal de Protección de Datos Personales en Posesión de 
              los Particulares.
            </p>

            <h2>7. Uso de cookies</h2>
            <p>
              Le informamos que en nuestra página de internet utilizamos cookies, web beacons y otras 
              tecnologías a través de las cuales es posible monitorear su comportamiento como usuario de 
              internet, brindarle un mejor servicio y experiencia de usuario al navegar en nuestra página.
            </p>

            <h2>8. Modificaciones al aviso de privacidad</h2>
            <p>
              Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones 
              al presente aviso de privacidad. Estas modificaciones estarán disponibles a través de nuestra 
              página de internet: {companyInfo.website}
            </p>

            <h2>9. Contacto</h2>
            <p>
              Si tiene alguna duda sobre este aviso de privacidad, puede contactarnos en:
            </p>
            <ul>
              <li>Email: {companyInfo.email}</li>
              <li>Teléfono: {companyInfo.phone}</li>
              <li>Dirección: {companyInfo.address}</li>
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AvisoPrivacidadPage;
